import React, { useState } from 'react';
import CustomerNumbersTable from './CustomerNumbersTable';
import CustomerBusinessNumbersTable from './CustomerBusinessNumbersTable';

type Props = {
    ownednumbers: any[];
    usedNumbers: any[];
    customerBusinessNumbers: any[];
};

const CustomerNumbers: React.FC<Props> = ({
    ownednumbers,
    usedNumbers,
    customerBusinessNumbers,
}) => {
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);

    const handleChangePage = (event: any, newPage: number) => {
        if (page < newPage) {
            setPage(newPage);
        } else {
            setPage(newPage);
        }
    };

    const handleChangeRowsPerPage = (event: any) => {
        setLimit(event.target.value);
        setPage(0);
    };
    return (
        <div className="mt-10">
            <CustomerNumbersTable
                title="Owned"
                numbers={ownednumbers}
                page={page}
                limit={limit}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
            />

            <CustomerNumbersTable
                title="Used"
                numbers={usedNumbers}
                page={page}
                limit={limit}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
            />

            <CustomerBusinessNumbersTable
                title="Business"
                businessNumbers={customerBusinessNumbers}
                page={page}
                limit={limit}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </div>
    );
};

export default CustomerNumbers;
